import React, { useEffect } from "react";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";

const SECTIONS = [
  {
    title: "1. Τιμές & Προσφορές",
    body: (
      <>
        Όλες οι τιμές και οι προσφορές που εμφανίζονται στον ιστότοπο, στον
        υπολογιστή κόστους ή σε οποιαδήποτε επικοινωνία είναι{" "}
        <strong>ενδεικτικές</strong> και δεν αποτελούν δεσμευτική προσφορά. Η
        τελική τιμή εξαρτάται από τις προδιαγραφές, την ποσότητα και τις τυχόν
        εξατομικευμένες απαιτήσεις κάθε παραγγελίας, και{" "}
        <strong>επιβεβαιώνεται γραπτώς μέσω email</strong> πριν από κάθε
        παραγγελία. Οι τιμές που σας αποστέλλονται ισχύουν για 30 ημέρες, εκτός
        αν αναφέρεται διαφορετικά.
      </>
    ),
  },
  {
    title: "2. Πνευματικά Δικαιώματα",
    body: (
      <>
        Ο σχεδιασμός, η τεχνολογία, το λογισμικό, τα υλικά και κάθε στοιχείο που
        αφορά τα προϊόντα VideoActive αποτελούν{" "}
        <strong>πνευματική ιδιοκτησία της SocialActive</strong>. Η αναπαραγωγή,
        αντιγραφή, τροποποίηση ή εμπορική εκμετάλλευσή τους χωρίς προηγούμενη
        γραπτή άδεια δεν επιτρέπεται. Το περιεχόμενο βίντεο που μας παρέχετε
        παραμένει δικό σας· εσείς δηλώνετε ότι έχετε τα σχετικά δικαιώματα χρήσης
        του.
      </>
    ),
  },
  {
    title: "3. Λογότυπο VideoActive",
    body: (
      <>
        Σε <strong>κάθε παραγγελία</strong>, τα προϊόντα φέρουν διακριτικά το
        λογότυπο της VideoActive. Πρόκειται για αναπόσπαστο μέρος του προϊόντος
        και της κατασκευαστικής μας ταυτότητας.
      </>
    ),
  },
  {
    title: "4. Παραγγελίες & Επιβεβαίωση",
    body: (
      <>
        Καμία παραγγελία δεν θεωρείται οριστική πριν από τη γραπτή επιβεβαίωση
        των προδιαγραφών και του κόστους και από τις δύο πλευρές. Πριν την τελική
        παραγωγή μπορεί να σας αποσταλεί δείγμα ή προσχέδιο προς έγκριση.
      </>
    ),
  },
  {
    title: "5. Χρόνοι Παραγωγής & Παράδοσης",
    body: (
      <>
        Οι χρόνοι παραγωγής και παράδοσης είναι κατά προσέγγιση και ενδέχεται να
        διαφοροποιηθούν ανάλογα με τη διαθεσιμότητα υλικών, την ποσότητα και
        παράγοντες εκτός του ελέγχου μας (π.χ. μεταφορές, εκτελωνισμός).
      </>
    ),
  },
  {
    title: "6. Προσωπικά Δεδομένα",
    body: (
      <>
        Τα στοιχεία που υποβάλλετε μέσω της φόρμας επικοινωνίας χρησιμοποιούνται
        αποκλειστικά για την εξυπηρέτηση του αιτήματός σας και την επικοινωνία
        μαζί σας. Δεν διαβιβάζονται σε τρίτους για διαφημιστικούς σκοπούς.
      </>
    ),
  },
];

export default function Terms() {
  // Ensure the page starts at the top when navigated to.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid="terms-page" className="bg-white">
      <Navbar />

      <section className="relative overflow-hidden bg-ink pt-28 pb-14 sm:pt-32">
        <div className="pointer-events-none absolute -right-20 top-10 h-72 w-72 rounded-full bg-brand-500/10 blur-3xl" />
        <div className="relative mx-auto max-w-3xl px-5 sm:px-8">
          <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.3em] text-brand-400">
            <span className="h-1.5 w-1.5 rounded-full bg-brand-500" />
            Νομικά
          </span>
          <h1 className="mt-4 font-display text-[clamp(2rem,4.5vw,3.4rem)] font-bold leading-[1.05] tracking-tight text-white">
            Όροι Επικοινωνίας
          </h1>
          <p className="mt-4 max-w-2xl text-lg text-white/70">
            Σύντομη παρουσίαση των βασικών όρων που διέπουν την επικοινωνία και
            τις παραγγελίες προϊόντων VideoActive της SocialActive.
          </p>
        </div>
      </section>

      <section className="py-14 sm:py-20">
        <div className="mx-auto max-w-3xl px-5 sm:px-8">
          <p className="text-base leading-relaxed text-ink/70">
            Καλώς ήρθατε στη VideoActive, προϊόν της SocialActive. Με τη χρήση
            της φόρμας επικοινωνίας ή την υποβολή αιτήματος παραγγελίας,
            αποδέχεστε τους παρακάτω όρους. Το παρόν κείμενο είναι ενημερωτικό και
            ενδέχεται να επικαιροποιείται.
          </p>

          <div className="mt-10 space-y-10">
            {SECTIONS.map((s) => (
              <div key={s.title}>
                <h2 className="font-display text-xl font-bold text-ink sm:text-2xl">
                  {s.title}
                </h2>
                <p className="mt-3 text-base leading-relaxed text-ink/70">
                  {s.body}
                </p>
              </div>
            ))}
          </div>

          <div className="mt-12 rounded-2xl border border-black/10 bg-secondary/50 p-6 sm:p-8">
            <h2 className="font-display text-xl font-bold text-ink">Επικοινωνία</h2>
            <p className="mt-3 text-base leading-relaxed text-ink/70">
              Για οποιαδήποτε διευκρίνιση σχετικά με τους παραπάνω όρους,
              επικοινωνήστε μαζί μας:
            </p>
            <ul className="mt-4 space-y-2 text-base text-ink/80">
              <li>
                Email:{" "}
                <a
                  href="mailto:info@videoactive.gr"
                  className="font-semibold text-brand-600 hover:underline"
                >
                  info@videoactive.gr
                </a>
              </li>
              <li>
                Τηλέφωνο:{" "}
                <a
                  href="tel:+302102202725"
                  className="font-semibold text-brand-600 hover:underline"
                >
                  +30 210 220 2725
                </a>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
